module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/edicao-fta/edicao-fta.component.css
// module id = ./src/app/edicao-fta/edicao-fta.component.css
// module chunks = main